module.exports = __webpack_public_path__ + "static/media/arrow.3aafaf20.svg";